import React from "react";
import { Bar } from "react-chartjs-2";

const SalesGrowthReport = ({
  chartData,
  chartOptions,
  formatSales,
  selectedStoreCode,
  chartRef,
  containerId,
}) => (
  <div ref={chartRef} id={containerId}>
    <div className="card">
      <Bar data={chartData} options={chartOptions} />
    </div>

    <div className="print-only-content">
      <h2>Report Details</h2>
      <div className="d-flex justify-content-between align-items-center print-only-content">
        <h3>Brand: Angels Pizza</h3>
        <h4 className="mx-auto"></h4>
        <h3>Store: {selectedStoreCode}</h3>
      </div>
      <div className="print-only" style={{ fontSize: "20px" }}>
        <table className="table text-center">
          <thead>
            <tr className="d-flex">
              <th>Month</th>
              <th className="ms-5">Sales</th>
              <th className="ms-5">Growth Percentage</th>
            </tr>
          </thead>
          <tbody>
            {chartData.labels.map((label, index) => (
              <tr className="d-flex" key={`${containerId}-${index}`}>
                <td>{label}</td>
                <td>{formatSales(chartData.datasets[0].data[index])}</td>
                <td>{formatSales(chartData.datasets[1].data[index])}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default SalesGrowthReport;
